import { auth, provider, signInWithPopup, signOut } from "./firebase";
import { Button, message } from "antd";
import { GoogleOutlined, LogoutOutlined } from "@ant-design/icons";

export default function Login({ user, onLogin }) {
  const handleSignIn = async () => {
    try {
      const result = await signInWithPopup(auth, provider);
      onLogin(result.user); // setUser(result.user)
      message.success(`Welcome ${result.user.displayName}`);
    } catch (error) {
      console.error("Google Sign-In Error:", error);
      message.error("Failed to sign in. Try again!");
    }
  };

  const handleSignOut = async () => {
    try {
      await signOut(auth);
      onLogin(null); // clear user
      message.success("Signed out successfully");
    } catch (error) {
      console.error("Sign-out failed:", error);
      message.error("Failed to sign out");
    }
  };

  return user ? (
    <Button
      icon={<LogoutOutlined />}
      onClick={handleSignOut}
      danger
    >
      Sign out
    </Button>
  ) : (
    <Button
      icon={<GoogleOutlined />}
      onClick={handleSignIn}
      type="primary"
    >
      Sign in with Google
    </Button>
  );
}
